import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  exportEmployeeRequestStart,
  exportEmployeeRequestSuccess,
  exportEmployeeRequestFailed,
} from "../redux/exportEmployeeRequest";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { formFilterEmployeeLeaveSelector } from "../redux/selector";
import { toast } from "react-toastify";
import { exportEmployeeRequestApi } from "core/http/service/employeeRequest";
import { declareLeaveURL } from "../Pages/Main/DeclareLeaveContent";
import moment from "moment";

export const typeScrollEmployeeRequest = {
  [declareLeaveURL.lackOfTime]: "employeeArriveLateRequest",
  [declareLeaveURL.leave]: "employeeLeaveRequest",
  [declareLeaveURL.feedback]: "employeeFeedbackRequest",
};

function* exportEmployeeRequestWork(action) {
  const type = action?.payload;

  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector(
      typeScrollEmployeeRequest[type] ||
        typeScrollEmployeeRequest[declareLeaveURL.leave]
    )
  );
  const form = yield select(formFilterEmployeeLeaveSelector);

  const params = {
    offset,
    limit,
    type,
    ...form,
    fromMonth: form.from?.month() + 1,
    fromYear: form.from?.year(),
    toYear: form.to?.year(),
    toMonth: form.to?.month() + 1,
  };
  try {
    const res = yield call(exportEmployeeRequestApi, {
      ...params,
    });

    const blob = new Blob([res], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = `Danh sách đơn CBNV_${moment(form?.from)?.format("MM-YYYY")} - ${moment(form?.to)?.format("MM-YYYY")}.xlsx`; // Name of the file to download

    // Append link to body and trigger download
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    yield put({
      type: exportEmployeeRequestSuccess.type,
    });
  } catch (error: any) {
    yield put({
      type: exportEmployeeRequestFailed.type,
    });
    toast.error("Đã có lỗi xảy ra");
  }
}

function* watchExportEmployeeRequest() {
  yield takeLatest(exportEmployeeRequestStart.type, exportEmployeeRequestWork);
}

export default function* exportEmployeeRequestSaga() {
  yield all([watchExportEmployeeRequest()]);
}
